import classNames from 'classnames';
import { Checkbox, Grid, Radio, Switch, Tooltip } from '@mui/material';
import { CheckBoxOutlineBlank } from '@mui/icons-material';
import withStyles from '@mui/styles/withStyles';
import {
  BaseInputErrorText,
  BaseInputHelperText,
  BaseInputLabel,
  Divider,
  FormControl,
  FormControlContext,
} from '../..';

const styles = () => ({
  item: {},
  fullWidth: {
    width: '100%',
  },
  labelStart: {
    marginRight: 10,
    whiteSpace: 'break-spaces',
  },
  labelEnd: {
    marginLeft: 10,
    whiteSpace: 'break-spaces',
  },
});

const defaultName = Math.random().toString(36).slice(2, 11);
const noopChange = () => null;

const SwitchControl = (props) => {
  const {
    classes,
    divider = true,
    fullWidth = true,
    labelPlacement: lp = 'top',
    name = defaultName,
    onChange = noopChange,
    value,
    helpText = '',
    label = 'Some label',
    errors = [],
    kind = 'checkbox',
    disabled = false,
    indeterminate = false,
    indeterminateIcon = <CheckBoxOutlineBlank style={{ color: '#0288d1' }} />,
    viewCheckedIcon,
    viewUncheckedIcon,
    mode,
    customCheckedIcon,
    customUncheckedIcon,
    disableRipple,
    showTooltip,
    tooltipTitle,
    ...rest
  } = props;

  const inputId = `${name}-switch`;
  const { item, fullWidth: fw, labelStart, labelEnd } = classes;

  const mapDirectionToLabelPlacement = {
    bottom: 'column-reverse',
    end: 'row-reverse',
    start: 'row',
    top: 'column',
  };

  const direction = mapDirectionToLabelPlacement[lp];
  const rootClassName = classNames(item, { [fw]: fullWidth });
  const labelClassName = classNames({
    [labelStart]: lp === 'start',
    [labelEnd]: lp === 'end',
  });
  const hasHelpText = Boolean(helpText);

  const viewIcon = (value && viewCheckedIcon) || (!value && viewUncheckedIcon) || null;

  const controlProps = {
    inputProps: { id: inputId },
    checked: value,
    disabled,
    onChange,
    name,
  };

  const customCheckbox =
    customCheckedIcon && customUncheckedIcon
      ? { icon: customUncheckedIcon, checkedIcon: customCheckedIcon }
      : {};

  const CheckToolTip = ({ show, title, children }) =>
    show ? <Tooltip title={title}>{children}</Tooltip> : <div>{children}</div>;

  const mapKindToControl = {
    checkbox: (
      <Checkbox
        onClick={(e) => {
          e.stopPropagation();
        }}
        indeterminate={indeterminate}
        indeterminateIcon={indeterminateIcon}
        disableRipple={disableRipple}
        {...controlProps}
        {...customCheckbox}
      />
    ),
    switch: <Switch {...controlProps} />,
    radio: <Radio {...controlProps} />,
  };

  const Control = mapKindToControl[kind];

  return (
    <FormControl {...rest}>
      <Grid container direction="column">
        <Grid item className={rootClassName}>
          <Grid
            container
            direction={direction}
            alignItems="center"
            justifyContent="space-between"
            wrap="nowrap"
          >
            <Grid item className={rootClassName}>
              <FormControlContext.Consumer>
                {(contextProps) => (
                  <BaseInputLabel
                    {...contextProps}
                    classes={{
                      root: labelClassName,
                    }}
                    htmlFor={inputId}
                  >
                    {label}
                  </BaseInputLabel>
                )}
              </FormControlContext.Consumer>
            </Grid>

            <Grid item>
              <FormControlContext.Consumer>
                {() =>
                  (mode === 'view' && viewIcon) || (
                    <CheckToolTip show={showTooltip} title={tooltipTitle}>
                      {Control}
                    </CheckToolTip>
                  )
                }
              </FormControlContext.Consumer>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <FormControlContext.Consumer>
            {(contextProps) => <BaseInputErrorText errors={errors} {...contextProps} />}
          </FormControlContext.Consumer>
        </Grid>

        <Grid item>
          <FormControlContext.Consumer>
            {(contextProps) => (
              <BaseInputHelperText {...contextProps}>
                {hasHelpText ? helpText : null}
              </BaseInputHelperText>
            )}
          </FormControlContext.Consumer>
        </Grid>
      </Grid>

      <Divider isVisible={divider} />
    </FormControl>
  );
};

const StyledSwitchControl = withStyles(styles)(SwitchControl);

export { StyledSwitchControl as SwitchControl };
